import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {ThongBao} from '../../models/info/thongbao';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
const apiUrl = `${environment.apiUrl}/api/info/thongbao`;

@Injectable({
  providedIn: 'root'
})
export class ThongBaoService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  public updateXuLy(params: Object): Observable<number>
  {
    return this.httpService.post(`${apiUrl}/updatexuly`, params).pipe(
      map(data => Number(data)));

  }
  public add(staffs: string, params: Object): Observable<ThongBao>
  {
    return this.httpService.post(`${apiUrl}/add?staffs=${staffs}`, params).pipe(
      map(data => new ThongBao().deserialize(data)));

  }
  public update(staffs: string, params: Object): Observable<ThongBao>
  {
    return this.httpService.post(`${apiUrl}/update?staffs=${staffs}`, params).pipe(
      map(data => new ThongBao().deserialize(data)));

  }
  public getCountByKeyword(keyword: string, staffId: number, nguoiNhapId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&uid=${staffId}&nid=${nguoiNhapId}`).pipe(
      map(data => Number(data)));
  }
  public getCountByDateKeyword(keyword: string, staffId: number, nguoiNhapId: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbydatekeyword?keyword=${keyword}&uid=${staffId}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getCountByTargetDateKeyword(keyword: string, searchType: number,  staffId: number, nguoiNhapId: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbytargetdatekeyword?keyword=${keyword}&stype=${searchType}&uid=${staffId}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getCountByKey(key: number, staffId: number, nguoiNhapId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykey?id=${key}&uid=${staffId}&nid=${nguoiNhapId}`).pipe(
      map(data => Number(data)));
  }
  public getCountByQLKeyword(keyword: string, nguoiNhapId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbyqlkeyword?keyword=${keyword}&nid=${nguoiNhapId}`).pipe(
      map(data => Number(data)));
  }
  public getCountByQLDateKeyword(keyword: string, nguoiNhapId: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbyqldatekeyword?keyword=${keyword}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getCountByTargetQLDateKeyword(keyword: string, searchType: number, nguoiNhapId: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbytargetqldatekeyword?keyword=${keyword}&stype=${searchType}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<ThongBao>
  {
    return this.httpService.get<ThongBao>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new ThongBao().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public getByReadId(id: number): Observable<ThongBao>
  {
    return this.httpService.get<ThongBao>(`${apiUrl}/findbyreadid/${id}`).pipe(
      map(data => new ThongBao().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public getByStaffReadId(id: number, staffId : number): Observable<ThongBao>
  {
    return this.httpService.get<ThongBao>(`${apiUrl}/findbystaffreadid/${id}?sid=${staffId}`).pipe(
      map(data => new ThongBao().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findByKeyword(keyword: String): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, staffId: number, nguoiNhapId: number, page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getallpaging?key=${keyword}&uid=${staffId}&nid=${nguoiNhapId}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByDatePaging(keyword: String, staffId: number, nguoiNhapId: number, fromDate: string, toDate: string, page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getalldatepaging?key=${keyword}&uid=${staffId}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }

  findAllByTargetDatePaging(keyword: String, searchType: number, staffId: number, nguoiNhapId: number, fromDate: string, toDate: string, page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getalltargetdatepaging?key=${keyword}&stype=${searchType}&uid=${staffId}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }

  findAllByKeyPaging(key: number, staffId: number, nguoiNhapId: number, page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getallpagingbykey?key=${key}&uid=${staffId}&nid=${nguoiNhapId}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByQLPaging(keyword: String,  nguoiNhapId: number, page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getallqlpaging?key=${keyword}&nid=${nguoiNhapId}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByQLDatePaging(keyword: String,  nguoiNhapId: number, fromDate: string, toDate: string,  page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getallqldatepaging?key=${keyword}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByTargetQLDatePaging(keyword: String, searchType: number,  nguoiNhapId: number, fromDate: string, toDate: string,  page: number, size: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/getalltargetqldatepaging?key=${keyword}&stype=${searchType}&nid=${nguoiNhapId}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByAlert(staffId: number, all: number): Observable<ThongBao[]> {
    return this.httpService.get<ThongBao[]>(`${apiUrl}/findallbyalert?id=${staffId}&all=${all}`).pipe(
      map(data => data.map(data => new ThongBao().deserialize(data)))
    );
  }
  findAllByCountAlert(staffId: number, all: number ){
    return this.httpService.get<ThongBao[]>(`${apiUrl}/findbycountalert?id=${staffId}&all=${all}`).pipe(
      map(data => Number(data)));
  }
}
